module.exports = __webpack_public_path__ + "static/media/swap.895271e9.png";